import { paymentConstants } from '../utils/types';
import { modals, paymentStatuses } from '../utils/constants';
import { openModal } from './modalsActions';
import ApiClient from '../utils/apiClient';

export function setPaymentStatus(paymentStatus, token) {
  return {
    type: paymentConstants.SET_PAYMENT_STATUS,
    payload: {
      paymentStatus,
      token
    }
  };
}

export function checkIfCardIsNew(token) {
  return dispatch => {
    ApiClient.post('/api/v1/is-card-used/', {
      source_token: token
    })
      .then(response => {
        if (response.data.is_card_used) {
          dispatch(openModal(modals.NO_TRIAL_WARNING_MODAL, { token }));
        } else {
          dispatch(setPaymentStatus(paymentStatuses.PROCESS_PAYMENT, token));
        }
      })
      .catch(() => {
        dispatch(setPaymentStatus(paymentStatuses.PAYMENT_FAILED));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/paymentActions.js